export const UnitRouting = [
  {
    path: "/material/unit/list",
    name: "basic-material-unit-list",
    meta: { title: "结算单位" },
    component: () =>
      import(
        /* webpackCh`un`kName: "basic-material-unit" */ "@/views/material/unit/list/index.vue"
      ),
  },
];
